<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formEnterprise">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteEnterprise()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="enterpriseContract.userNameCreate"
              [createDate]="enterpriseContract.createDate" [userNameUpdate]="enterpriseContract.userNameUpdate"
              [updateDate]="enterpriseContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-between">
        <div class="col-lg-6 col-sm-12 col-12">
          <div class="row">
            <div class="col field-branchId">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [recovery]="true" [required]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col field-code">
              <app-custom-input-number formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
                (onChangeNumber)="changeCode($event)"></app-custom-input-number>
            </div>
            <div class="col state">
              <div class="col field-tag">
                <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateEnterprise">
                </app-custom-tag>
              </div>
              <div class="col field-button">
                <app-custom-button [title]="titleState" [icon]="icon" [severity]="'primary'"
                  (onClick)="changeStateEnterprise()">
                </app-custom-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col field-typeDocumentId">
              <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                [list]="listTypeDocument" [required]="true"></app-custom-select>
            </div>
            <div class="col field-document">
              <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                (onChangeTextOnBlur)="getDigitVerification($event)" [maxLength]="15"></app-custom-input-text>
            </div>
            <div class="col field-digitVerification">
              <app-custom-input-text formControlName="digitVerification" [labelText]="'D.Verif.'" [required]="true">
              </app-custom-input-text>
            </div>
          </div>
          <div class="row">
            <div class="col field-typePersonId">
              <app-custom-select formControlName="typePersonId" [labelText]="'Tipo Persona'" [list]="listTypePerson"
                [required]="true" (onChangeSelect)="changeTypePerson($event)"></app-custom-select>
            </div>
            <div class="col field-names">
              <app-custom-input-text formControlName="names" [labelText]="'Nombres'" (onChangeText)="changeNames()"
                [maxLength]="75">
              </app-custom-input-text>
            </div>
            <div class="col field-lastNames">
              <app-custom-input-text formControlName="lastNames" [labelText]="'Apellidos'"
                (onChangeText)="changeNames()" [maxLength]="75"></app-custom-input-text>
            </div>
            <div class="col field-businessName">
              <app-custom-input-text formControlName="businessName" [labelText]="'Razón Social'" [required]="true"
                [maxLength]="100"></app-custom-input-text>
            </div>
            <div class="col field-businessName2">
              <app-custom-input-text formControlName="businessName2" [labelText]="'Razón Social 2'" [maxLength]="150">
              </app-custom-input-text>
            </div>
            <div class="col field-webPage">
              <app-custom-input-text formControlName="webPage" [labelText]="'Página Web'" [maxLength]="70">
              </app-custom-input-text>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12 col-12">
          <div class="row justify-content-end">
            <div class="col-lg-10 col-md-12 col-12">
              <div class="row">
                <fieldset class="border">
                  <legend>Configuración General:</legend>
                  <div class="checkbox-container">
                    <div class="field-checkbox">
                      <app-custom-checkbox formControlName="swStoreInterface"
                        [labelText]="'Interfaz Bod.'"></app-custom-checkbox>
                    </div>
                    <div class="field-checkbox">
                      <app-custom-checkbox formControlName="swSelfRetainer"
                        [labelText]="'Autoretenedor'"></app-custom-checkbox>
                    </div>
                    <div class="field-checkbox">
                      <app-custom-checkbox formControlName="swSimpleTaxRegime" [labelText]="'Reg.Simp.Trib.'"
                        (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
                    </div>
                    <div class="field-checkbox">
                      <app-custom-checkbox formControlName="swIvaResponsible" [labelText]="'Respon.Iva'"
                        (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
                    </div>
                    @if (visibleSwGreatContributor) {
                    <div class="field-checkbox">
                      <app-custom-checkbox formControlName="swGreatContributor" [labelText]="'Gran Contrib.'">
                      </app-custom-checkbox>
                    </div>
                    }
                  </div>
                </fieldset>
              </div>
              <div class="row">
                <fieldset class="border">
                  <legend>
                    <div class="field-checkbox-swElectronicInvoice">
                      <app-custom-checkbox formControlName="swElectronicInvoice"
                        [labelText]="'Facturación Electrónica:'" (onChangeCheckBox)="changeElectronicInvoice($event)">
                      </app-custom-checkbox>
                    </div>
                  </legend>
                  <div class="row">
                    <div class="col field-tecnologyProviderId">
                      <app-custom-select formControlName="tecnologyProviderId" [labelText]="'Prov.Tecnológico'"
                        [list]="listTecnologyProvider" [required]="swElectronicInvoice"></app-custom-select>
                    </div>
                    <div class="col field-tecnologyProviderUser">
                      <app-custom-input-text formControlName="tecnologyProviderUser" [required]="swElectronicInvoice"
                        [labelText]="'Usuario Prov.Tecn.'" [maxLength]="250"></app-custom-input-text>
                    </div>
                    <div class="col field-tecnologyProviderPassword">
                      <app-custom-input-text formControlName="tecnologyProviderPassword"
                        [labelText]="'Contraseña Prov.Tecn.'" [required]="swElectronicInvoice"
                        [maxLength]="250"></app-custom-input-text>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="row">
                <div class="col field-buttons">
                  <!-- Opciones avanzadas  -->
                  <app-custom-button [title]="'Opciones Avanzadas'" [label]="'Opciones Avanzadas'"
                    [severity]="'contrast'" [width]="'9rem'" (onClick)="openAdvancedOptions()">
                  </app-custom-button>
                  <app-custom-modal #advancedOptions [label]="'Opciones Avanzadas'" [header]="'Opciones Avanzadas'"
                    [inputs$]="inputsForAdvancedOptionsModals$" [children]="componentAdvancedOptions" [width]="'60vw'"
                    hidden>
                  </app-custom-modal>
                  <!-- Datos por ciudad -->
                  <app-custom-button [title]="'Datos por Ciudad '" [label]="'Datos Ciudad'" [icon]="'pi pi-globe'"
                    [width]="'9rem'" (onClick)="openEnterpriseCity()">
                  </app-custom-button>
                  <app-custom-modal #enterpriseCity [label]="'Datos por Ciudad'" [header]="'Datos por Ciudad'"
                    [inputs$]="inputsForEnterpriseCityModals$" [children]="componentEnterpriseCity" [width]="'60vw'"
                    hidden>
                  </app-custom-modal>

                  <!-- Adjuntar imagenes -->
                  <app-custom-button [title]="'Adjuntar Imágenes'"
                    [label]="hasAnyImage() ? 'Ver Logos' : 'Adjuntar Logos'"
                    [width]="hasAnyImage() ? '7.5rem' : '8.5rem'" [severity]="'success'"
                    [icon]="hasAnyImage() ? 'pi pi-images' : 'pi pi-upload'"
                    (onClick)="openAttachImages()"></app-custom-button>
                  <app-custom-modal #attachImages [label]="'Adjuntar Imágenes'" [header]="'Adjuntar Imágenes'"
                    [children]="componentAttachImages" [inputs$]="inputsForAttachImages$" [width]="'60vw'"
                    [output$]="outputAttachImages$" hidden></app-custom-modal>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col field-button-save">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                  [disabled]="disabledForm" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>